import { CalendarDays, ClipboardList, ListOrdered } from "lucide-react";
import { T } from "../lib/theme";

export type Tab = "upnext" | "record" | "meetings" | "members";

/** Three tabs, not four. Members is reached from the people icon in the Up Next
 *  header because it's used rarely — but it deliberately keeps Up Next lit while
 *  you're in there, so the tab bar reflects where you came from rather than
 *  showing nothing selected. */
export function TabBar({ tab, setTab }: { tab: Tab; setTab: (t: Tab) => void }) {
  const items = [
    { k: "upnext" as const, label: "Up Next", Icon: ListOrdered },
    { k: "record" as const, label: "Record", Icon: ClipboardList },
    { k: "meetings" as const, label: "Meetings", Icon: CalendarDays },
  ];

  return (
    <div
      style={{
        position: "fixed",
        bottom: 0,
        left: 0,
        right: 0,
        background: "#fff",
        borderTop: `1px solid ${T.line}`,
        display: "flex",
        zIndex: 50,
        paddingBottom: "env(safe-area-inset-bottom)",
      }}
    >
      <div style={{ maxWidth: 520, margin: "0 auto", display: "flex", width: "100%" }}>
        {items.map(({ k, label, Icon }) => {
          const on = tab === k || (k === "upnext" && tab === "members");
          return (
            <button
              key={k}
              onClick={() => setTab(k)}
              aria-current={on ? "page" : undefined}
              style={{
                flex: 1,
                padding: "9px 0 11px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: 3,
                color: on ? T.navy : T.faint,
              }}
            >
              <Icon size={21} strokeWidth={on ? 2.3 : 1.8} />
              <span style={{ fontSize: 10.5, fontWeight: on ? 600 : 500 }}>{label}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
